import React from 'react';
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Privacy Policy Page",
  });

  return (
    <>
      <Helmet>
        <title>سياسة الخصوصية - محصول</title>
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool, Privacy Policy" />
        <meta property="og:title" content="سياسة الخصوصية - محصول" />
        <meta property="og:description" content="Privacy policy of Mahsool platform." />
        <meta property="og:locale" content="ar_AR" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div
        className="w-screen px-20 flex items-center flex-col mt-10 font-semibold text-lg"
        dir="rtl"
      >

        <div className="h-20" />
        <span className="text-2xl mb-5">سياسة الخصوصية لمنصة محصول</span>
        <div className="space-y-4">
          <p>
            مرحبًا بكم في منصة محصول، وهي منصة تابعة لشركة ACTS لتقنيات الحاسوب والاتصالات المتقدمة. نحن ملتزمون بحماية خصوصيتكم وضمان أمن بياناتكم الشخصية. تسعى سياسة الخصوصية هذه إلى شرح كيفية جمع واستخدام وحماية المعلومات الشخصية التي تقدمونها عند استخدام منصتنا وخدماتنا.
          </p>
          <h2 className="text-xl">1. المعلومات التي نجمعها</h2>
          <p>
            نقوم بجمع أنواع مختلفة من المعلومات لتحقيق تجربة مستخدم متميزة، بما في ذلك:
          </p>
          <ul className="list-disc pl-5">
            <li>المعلومات الشخصية: مثل الاسم، البريد الإلكتروني، رقم الهاتف، والعنوان.</li>
            <li>المعلومات المتعلقة بالمعاملات: مثل تفاصيل المنتجات والخدمات التي تتعاملون معها.</li>
            <li>المعلومات التقنية: مثل عنوان الـ IP، نوع المتصفح، وسجل التصفح.</li>
          </ul>
          <h2 className="text-xl">2. كيفية استخدام المعلومات</h2>
          <p>
            نستخدم المعلومات التي نجمعها للأغراض التالية:
          </p>
          <ul className="list-disc pl-5">
            <li>تحسين الخدمات: لتحسين وتخصيص تجربتكم على منصتنا.</li>
            <li>التواصل: للرد على استفساراتكم وتقديم الدعم الفني.</li>
            <li>الإعلانات والعروض: لإرسال إعلانات وعروض خاصة تتعلق بمنتجات وخدمات منصة محصول.</li>
          </ul>
          <h2 className="text-xl">3. مشاركة المعلومات</h2>
          <p>
            لن نقوم ببيع أو تأجير أو تبادل معلوماتكم الشخصية مع أطراف ثالثة بدون موافقتكم المسبقة، باستثناء:
          </p>
          <ul className="list-disc pl-5">
            <li>مقدمي الخدمات: الذين يساعدوننا في تشغيل وصيانة منصتنا.</li>
            <li>الالتزام بالقوانين: عندما يكون ذلك مطلوبًا بموجب القانون أو استجابة لأوامر قضائية.</li>
          </ul>
          <h2 className="text-xl">4. أمان المعلومات</h2>
          <p>
            نستخدم تقنيات وإجراءات أمان متقدمة لحماية بياناتكم الشخصية من الوصول غير المصرح به، الاستخدام غير المشروع، أو الكشف عنها.
          </p>
          <h2 className="text-xl">5. حقوقكم</h2>
          <ul className="list-disc pl-5">
            <li>الوصول والتصحيح: يمكنكم طلب الوصول إلى البيانات الشخصية التي نحتفظ بها وتصحيحها إذا كانت غير دقيقة.</li>
            <li>الاعتراض والحذف: يمكنكم الاعتراض على معالجة بياناتكم الشخصية وطلب حذفها في أي وقت.</li>
          </ul>
          <h2 className="text-xl">6. ملفات تعريف الارتباط (Cookies)</h2>
          <p>
            تستخدم منصتنا ملفات تعريف الارتباط لتحسين تجربتكم على الموقع. يمكنكم التحكم في ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاص بكم.
          </p>
          <h2 className="text-xl">7. التغييرات على سياسة الخصوصية</h2>
          <p>
            قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سيتم إشعاركم بأي تغييرات هامة من خلال البريد الإلكتروني أو من خلال إشعار على منصتنا.
          </p>
          <h2 className="text-xl">8. الاتصال بنا</h2>
          <p>
            إذا كان لديكم أي استفسارات أو مخاوف بشأن سياسة الخصوصية هذه، يرجى الاتصال بنا عبر:
          </p>
          <ul className="list-disc pl-5">
            <li>البريد الإلكتروني: [ help@mahsool.sd]</li>
            <li>
              <div className="flex">
                <div>
                او مباشرة عبر:
                </div>
                <a
                  href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
                  target="_blank"
                  className="hover:scale-110 transition-all mx-2"
                >
                  <img
                    src="https://i.ibb.co/3fmF4zH/icons8-facebook-48.png"
                    alt=""
                    className="w-9"
                  />
                </a>
                
                <a
                  href="https://wa.me/message/K5BD6QOI2BBYE1"
                  target="_blank"
                  className="hover:scale-110 transition-all mx-2"
                >
                  <img
                    src="https://i.ibb.co/k2rf8LM/icons8-whatsapp-48-1.png"
                    alt=""
                    className="w-9"
                  />
                </a>
              </div>
            </li>
            
          </ul>
          <p>
            نشكركم على ثقتكم في منصة محصول، ونحن ملتزمون بحماية خصوصيتكم وضمان أمان معلوماتكم الشخصية.
          </p>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
